import { IUserInfoDto } from "@kuika/kuika-cl-model";

/**
 * `createdAt` is served by /auth/userinfo but is not declared on the shared DTO, and
 * kuika-cl-model is a Top-risk schema — so the field is widened here instead. Optional on
 * purpose: if the backend stops sending it the line disappears rather than rendering
 * "Invalid Date".
 */
export interface IUserInfoWithCreatedAt extends IUserInfoDto {
  createdAt?: string;
}

/** "June 2026", or "" when there is nothing to say. Shared by the rail and the profile form. */
export const formatMemberSince = (createdAt: string | undefined): string => {
  if (!createdAt) return "";
  const date: Date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
};
